import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormControl, FormGroup, InputGroup, Button } from 'react-bootstrap'
import { tableHelper, momentHelper } from './helpers'
import ReportStore from '../../stores/ReportStore'
import FontAwesome from 'react-fontawesome';
import IframeModal from '../../component/element/IframeModal'
import './report.css'

class ReportKKCReceivableCash extends Component {
  constructor(props) {
    super(props)

    this.state = {loading:false}
  }

  componentDidMount(){
   
  }

  loadData(){

  }

  onPrintClick() {
    let url = ''
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportKKCReceivableCash'
    } else{
      url = './pdf/v2?startPage=PrintReportKKCReceivableCash'
    }
    this.refs.iframe.loadUrl(url)
  }

  renderRowData() {
    return('')
  }

  renderTable() {
     return(
      <div className='display-overflow'>
        <table className='table table-responsive table-hover table-bordered-solid table-report-kkc-receivable-cash' style={{width:'2100px'}}>
          <thead>
            <tr>
              <th rowSpan={2} className='text-center bg-none' style={{width:'50px'}}>ลำดับ</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'200px'}}>เจ้าของรถ</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'200px'}}>ทะเบียบรถ</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'90px'}}>วันที่รับเงิน</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>จำนวนเงินอนุมัติ<br/>เข้าซ่อม</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>จำนวนเงิน<br/>ภาษี 7%</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>จำนวนเงิน<br/>ก่อนรวมภาษี 7%</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>จำนวนเงิน<br/>หักภาษี 3%</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>จำนวนเงิน<br/>หลังหักภาษี 3%</th>
              <th className='text-center bg-none' style={{width:'100px'}}>โอนเข้าบัญชี</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'150px'}}>ผ่านธนาคาร</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'220px'}}>หมายเหตุ</th>
            </tr>
            <tr>
              <th className='text-center bg-none'>บาท</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td className='text-center bg-2 color-red'>รับเงินปี 2559 - 2560</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td className='text-center'>961060</td>
              <td>เงินสด</td>
              <td>บม-7886</td>
              <td className='text-center'>07/03/61</td>
              <td className='text-right'>3,500.00</td>
              <td className='text-right'></td>
              <td className='text-right'></td>
              <td className='text-right'></td>
              <td className='text-right'></td>
              <td className='text-right'>3,500.00</td>
              <td className='text-center'></td>
              <td></td>
            </tr>
            <tr>
              <td className='summary text-center bg-1'></td>
              <td className='summary bg-1'></td>
              <td className='summary bg-1'></td>
              <td className='summary text-center bg-1'></td>
              <td className='summary text-right bg-1'>3,500.00</td>
              <td className='summary text-right bg-1'></td>
              <td className='summary text-right bg-1'></td>
              <td className='summary text-right bg-1'></td>
              <td className='summary text-right bg-1'></td>
              <td className='summary text-right bg-1 color-red'>3,500.00</td>
              <td className='summary text-center bg-1'></td>
              <td className='summary bg-1'></td>
            </tr>
            <tr>
              <td className='text-center'>961060</td>
              <td>เงินสด</td>
              <td>บม-7886</td>
              <td className='text-center'>07/03/61</td>
              <td className='text-right'>3,500.00</td>
              <td className='text-right'></td>
              <td className='text-right'></td>
              <td className='text-right'></td>
              <td className='text-right'></td>
              <td className='text-right'>3,500.00</td>
              <td className='text-center'></td>
              <td></td>
            </tr>
            {this.renderRowData()}
          </tbody>  
        </table>
      </div>
    )      
  }

  render() {
    return(
      <Box>
        <Box.Header border={true}>          
          <Box.Title>{this.props.renderMenu()}</Box.Title>
          <Box.Tools >
            <Button                 
              bsStyle={'link'} className='bg-maroon'
              onClick={this.onPrintClick.bind(this)}
            >
              <FontAwesome name='print'/>&nbsp;พิมพ์เอกสาร
            </Button>                           
          </Box.Tools>
        </Box.Header>
        <Box.Body>
          {this.renderTable()}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
} 

ReportKKCReceivableCash.defaultProps = {
  show : false
}

export default ReportKKCReceivableCash; 


// WEBPACK FOOTER //
// ./src/view/report/ReportKKCReceivableCash.js